import React from 'react'
import HeaderTop from './components/HeaderTop'
import AppRouter from './router/AppRouter'

const App = () => {
  return (
   <>
   <AppRouter/>
   </>
  )
}

export default App
